import { GameConstants } from "./GameConstants";
import { PreLoader } from "./PreLoader";
import { SplashState } from "./splash/SplashState";
import { BoardState } from "./board/BoardState";
import { PuzzleSelectionState } from "./puzzle-selection/PuzzleSelectionState";
import { ChallengeState } from "./challenge/ChallengeState";
import { Boot } from "./Boot";

export class Game extends Phaser.Game {

    public static currentInstance: Game;

    constructor() {

        let renderer: number;

        if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i)) {
            renderer = Phaser.CANVAS;
        } else {
            renderer = Phaser.AUTO;
        }
        
        super(GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT, renderer, "content", null, false, true );

        Game.currentInstance = this;

        this.state.add("PreLoader", PreLoader, false);
        this.state.add("SplashState", SplashState, false);
        this.state.add("BoardState", BoardState, false);
        this.state.add("PuzzleSelectionState", PuzzleSelectionState, false);
        this.state.add("ChallengeState", ChallengeState, false);
        
        this.state.add("Boot", Boot, true);
    }
}
